import React from 'react';
import Stack from "@mui/material/Stack";
import IncidentsGraphs from "../../components/Graph/IncidentGraphs";

const IncidentsAnalytics = () => {
    return <Stack gap={2}>
        <IncidentsGraphs />
    </Stack>
}

export default IncidentsAnalytics;